const sizeCalculatorStyle = {
  position: 'fixed',
  top: '120vh',
  'background-color': 'red'
};

// Goes through the keys of the given style element and applies them
function applyStyle(element, style) {
  for (const key in style) {
    element.style[key] = style[key];
  }
}

/*
 * Uses the size-calculator element in Root to calculate the height of a text
 * element, turning linebreaks into <br /> elements
 */
function calculateSize(caption, options = {}) {
  if (!caption) return caption;

  // Get props
  const {
    wrapperStyle = {},
    textStyle = {
      textAlign: 'left',
      fontSize: '16px',
      lineHeight: '18px',
      fontWeight: 400,
      fontFamily: 'CeraPro',
      wordBreak: 'breakWord'
    },
    numberOfLines,
    addToStart = ''
  } = options;

  /*
   * Replace the non-digits in the lineHeight property to nothing, then turn it
   * into a number
   */
  const lineHt = parseInt(
    (textStyle.lineHeight || wrapperStyle.lineHeight || '18').replace(/^\D+/g, '')
  );

  // Turn the caption into a array, with each member of the array being seperated
  // by a line break
  const transformedCaption = (addToStart + caption).split('\n');

  const root = document.getElementById('root');

  const newSizeCalculator = document.createElement('div');
  applyStyle(newSizeCalculator, sizeCalculatorStyle);

  // Get the size-calculator element at root
  const sizeCalculator = root.appendChild(newSizeCalculator);

  // Create the wrapper element
  const Element = document.createElement('p');
  applyStyle(Element, wrapperStyle);

  /*
   * Go through the transformedCaption array, turn the string into a <p> element
   * with the string inside it and place the <br> where it needs to be
   */
  for (var i = 0; i < transformedCaption.length; i++) {
    // Create a text node to put inside the <p> element created
    const textNode = document.createTextNode(transformedCaption[i]);

    // Create a p element
    const subElement = document.createElement('span');
    applyStyle(subElement, textStyle);

    // Put the text inside the <p> element
    subElement.appendChild(textNode);

    // Put the <p> element inside the wrapper element
    Element.appendChild(subElement);

    // If this is not the last element, put a linebreak element after the <p>
    if (i !== transformedCaption.length - 1) {
      Element.appendChild(document.createElement('br'));
    }
  }

  // Put the wrapper in the size-calculator to render it
  sizeCalculator.appendChild(Element);

  // Get the dimensions
  const res = sizeCalculator.getBoundingClientRect();

  /*
   * We get the line count, <br /> are 1px bigger than line height, and <p> tags
   * inherently add 0.4 px to the line height
   */
  res.lineCount = calculateLineCount(res.height, transformedCaption.length - 1, lineHt + 0.4);

  // If the numberOfLines is inputted, try to cut the text until it fits
  if (numberOfLines) {
    res.calculatedText =
      calculateLines({
        res,
        sizeCalculator,
        numberOfLines,
        lineHt: lineHt + 0.4,
        lineBreakCount: transformedCaption.length,
        textStyle
      }) || caption;

    // If there's an text for indent at the start remove that before you send the caption
    if (addToStart) res.calculatedText = res.calculatedText.replace(addToStart, '');
  }

  // Clean up the size-calculator for the next use
  root.removeChild(sizeCalculator);

  return res;
}

/*
 * Get the line count, due to floating point calculations and other dom
 * inaccuracies with floating points, we round the number
 */
function calculateLineCount(height, lineBreakCount, lineHt) {
  return Math.round((height - lineBreakCount * 1) / lineHt);
}

/*
 * Try to fit the given string into the given number of lines
 */
function calculateLines({ res, sizeCalculator, numberOfLines, lineHt, lineBreakCount, textStyle }) {
  // If it already fits, just return
  if (res.lineCount <= numberOfLines) return;

  // Get the <p> element
  const Element = sizeCalculator.children[0];

  // Flatten the element
  const flattened = document.createElement('span');
  applyStyle(flattened, textStyle);
  flattened.appendChild(document.createTextNode(Element.innerText.replaceAll('\n', ' ')));

  // Remove all existing children
  while (Element.children.length) Element.removeChild(Element.lastChild);
  Element.appendChild(flattened);

  // This while will run as long as the text doesn't fit in the given lines
  while (
    calculateLineCount(sizeCalculator.getBoundingClientRect().height, lineBreakCount, lineHt) >
    numberOfLines
  ) {
    // Get the last element
    const subElement = Element.lastChild;

    /*
     * If the last element is text and it has text inside of it, cut 10 characters
     * from the end of it, if it is a linebreak or it is an empty string, remove it
     */
    switch (subElement.localName) {
      case 'span':
        if (subElement.innerText.length) {
          subElement.innerText = subElement.innerText.slice(0, -10);
          break;
        }
      // There is no break in this line so it runs the code 2 lines below
      case 'br':
        Element.removeChild(subElement);
    }
  }

  return Element.innerText;
}

export default calculateSize;
